const FitmentLabel = ({
  modelText,
  equipmentFamilyText,
  serialNumberText,
  fitmentDisplayText,
  isCard = false
}) => {
  const modelLabel = modelText ? ` ${modelText}` : '';
  const serialNumberLabel = serialNumberText ? ` ${serialNumberText}` : '';
  const equipmentFamilyLabel = equipmentFamilyText
    ? ` ${equipmentFamilyText}`
    : '';

  if (isCard) {
    return `${fitmentDisplayText}${modelLabel}${serialNumberLabel}`;
  }

  return `${modelLabel}${equipmentFamilyLabel}${serialNumberLabel}`;
};

export default FitmentLabel;
